export const unitsMeasure = {
    m: { name: "metros", abbreviation: "m" },
    m3: { name: "metros cubicos", abbreviation: "m3" },
    tn: { name: "toneladas", abbreviation: "tn" },
    km: { name: "kilometros", abbreviation: "km" },
    vanos: { name: "vanos", abbreviation: "vanos" }, 
    NA: {name: "No Aplica", abbreviation: "N/A"} 
} as const;

export const unitsProduction = {
  Torres: { name: "Torres", abbreviation: "Torres" },
  m: { name: "metros", abbreviation: "m" },
  ud: { name: "unidad", abbreviation: "ud" },
  km: { name: "kilometros", abbreviation: "km" },
  vanos: { name: "vanos", abbreviation: "vanos" }, 
  NA: {name: "No Aplica", abbreviation: "N/A"} 
} as const;